var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/shop-order-history-detail.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-79d461c3!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/shop-order-history-detail.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ShopOrderHistoryDetail.vue
// module id = 733
// module chunks = 1